<!-- -->
<template>
  <div :class="{ business: true, 'm-business': isMobile }">
    <Dialog :show.sync="show" />
    <div class="banner">
      <img :src="activeNav.bg" alt="" />
      <div class="in">
        <div class="title">{{ activeNav.name }}</div>
        <div class="sub">{{ activeNav.desc }}</div>
        <div class="btns">
          <button class="btn primary" @click="openDialog">提交需求</button>
        </div>
        <div class="line"></div>
      </div>
    </div>
    <div class="navs">
      <router-link
        :to="'/business/' + item.key"
        :class="{ nav: true, active: item.key == businessType }"
        v-for="item in navList"
        :key="item.key"
      >
        <img :src="item.icon" alt="" class="icon" />
        <div class="name">{{ item.name }}</div>
      </router-link>
    </div>
    <component :is="businessType" @openDialog="openDialog"></component>
    <div class="contact">
      <img :src="activeNav.formBg" alt="" class="type-banner" />
      <div class="bottom">
        <div class="left">
          <div class="title">联系我们</div>
          <div class="sub">简单3步便可以开始推广</div>
          <div class="steps">
            <div class="step">
              <div class="order">1</div>
              <div class="txt">确认推广意向</div>
            </div>
            <div class="step">
              <div class="order">2</div>
              <div class="txt">为您开通账号</div>
            </div>
            <div class="step">
              <div class="order">3</div>
              <div class="txt">开启您的投放</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="item">
            <div class="label">所在区域</div>
            <div class="value">
              <input v-model="addParams.address" type="text" class="ipt" />
            </div>
          </div>
          <div class="item require">
            <div class="label">咨询内容</div>
            <div class="value">
              <input v-model="addParams.content" type="text" class="ipt" />
            </div>
          </div>
          <div class="item require">
            <div class="label">
              姓&thinsp;&thinsp;&thinsp;&thinsp;&thinsp;&thinsp;&thinsp;名
            </div>
            <div class="value">
              <input v-model="addParams.userName" type="text" class="ipt" />
            </div>
          </div>
          <div class="item require">
            <div class="label">联系电话</div>
            <div class="value">
              <input v-model="addParams.phone" type="text" class="ipt" />
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <button class="submit" @click="submitForm">提交</button>
        <div class="phone">咨询电话: {{ globalConfig.consultPhone }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "@/util/config";
import Search from "../components/business/search.vue";
import Info from "../components/business/info.vue";
import Aicaigou from "../components/business/aicaigou.vue";
import Brand from "../components/business/brand.vue";
import Ad from "../components/business/ad.vue";
import Web from "../components/business/web.vue";
import RedBook from "../components/business/redBook.vue";
import Geo from "../components/business/geo.vue";
import Dialog from "../components/dialog.vue";

import { Store } from "@/store/index.js";
import { mapState } from "pinia";
export default {
  components: {
    Search,
    Info,
    Aicaigou,
    Brand,
    Ad,
    Web,
    RedBook,
    Geo,
    Dialog,
  },
  data() {
    return {
      show: false, // 弹窗控件
      navList: [
        {
          key: "Search",
          name: "百度搜索",
          icon: URL + "business_search.png",
          bg: URL + "search_bg.jpg",
          formBg: URL + "search_form.jpg",
          desc: "百度系列产品每天超60亿次搜索请求\n超过1亿用户浏览百度信息流、800亿次定位服务请求\n覆盖用户生活全场景",
        },
        {
          key: "Info",
          name: "百度信息流",
          icon: URL + "business_info.png",
          bg: URL + "info_bg.png",
          formBg: URL + "info_from.png",
          desc: "将您的推广信息自然融入在各类资讯、信息中，易传播，易操作",
        },
        {
          key: "Aicaigou",
          name: "百度爱采购",
          icon: URL + "business_aicaigou.png",
          bg: URL + "aicaigou_bg.png",
          formBg: URL + "aicaigou_from.png",
          desc: "帮助用户一站直达全网商品信息，触达海量优质商家，通过安全便捷的交易能力全网采购",
        },
        {
          key: "Brand",
          name: "百度品牌专区",
          icon: URL + "business_brand.png",
          bg: URL + "brand_bg.png",
          formBg: URL + "brand_from.png",
          desc: "品牌专区，快速建立您的企业品牌公信力，首位霸屏，强展现",
        },
        {
          key: "Ad",
          name: "百度开屏广告",
          icon: URL + "business_ad.png",
          bg: URL + "ad_bg.png",
          formBg: URL + "ad_from.png",
          desc: "百度开屏矩阵，是以围绕百度APP搭建的百度系开屏产品矩阵",
        },
        {
          key: "Geo",
          name: "GEO服务",
          icon: "./geo/icon.svg",
          bg: "./geo/geo_bg.png",
          formBg: URL + "web_from .png",
          desc: "AI 时代全新营销方式，助力企业在豆包、DeepSeek、ChatGPT 等大模型平台\n抢占问答入口，实现全平台精准获客",
        },
        {
          key: "RedBook",
          name: "小红书",
          icon: URL + "business_redBook.png",
          bg: URL + "redBook_bg.jpg",
          formBg: URL + "web_from .png",
          desc: "中国最大的生活方式平台，能够满足广告主以“产品种草、商品销量、客资收集、直播推广、抢占赛道”为目标的多样化营销诉求。",
        },
        {
          key: "Web",
          name: "网站建设",
          icon: URL + "business_web.png",
          bg: URL + "web_bg.png",
          formBg: URL + "web_from .png",
          desc: "盘古广告建站是帮助中小企业快速搭建企业网站的自助建站产品",
        },
      ],
      activeNav: {}, // 激活业务
      businessType: "", // 业务key值，用于判断渲染哪个业务组件
      addParams: {
        address: "",
        userName: "",
        content: "",
        phone: "",
      },
      addRules: {
        userName: { message: "请输入姓名" },
        content: { message: "请输入咨询内容" },
        phone: { message: "请输入联系电话" },
      },
    };
  },
  computed: {
    ...mapState(Store, ["globalConfig", "isMobile"]),
  },
  created() {
    const { key } = this.$route.params;
    this.businessType = key;
    this.activeNav = this.navList.find((ele) => ele.key == key) || {};
  },
  methods: {
    openDialog() {
      if (this.isMobile) {
        this.$router.push("/contact");
        return;
      }
      this.show = true;
    },
    submitForm() {
      for (const key in this.addRules) {
        if (!this.addParams[key]) {
          this.$notify.error({ title: this.addRules[key].message });
          return;
        }
      }
      // 校验通过
      this.$api.addFeedBack(this.addParams).then((res) => {
        if (res.code == 0) {
          this.$notify.success({ title: "提交成功!" });
          Object.assign(this.$data.addParams, this.$options.data().addParams);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;

  &::after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba($color: #fff, $alpha: 0.4);
  }
  img {
    width: 100%;
    height: 650px;
    object-fit: cover;
  }
  .in {
    width: 1200px;
    position: absolute;
    left: 50%;
    top: 130px;
    transform: translateX(-50%);
    z-index: 2;

    .title {
      font-size: 56px;
      font-weight: bold;
    }
    .sub {
      margin-top: 50px;
      height: 100px;
      color: #2a2f39;
      font-size: 23px;
      line-height: 35px;
      white-space: pre-wrap;
    }
    .btns {
      margin-top: 90px;
      display: flex;

      .btn {
        width: 170px;
        height: 53px;
        font-size: 21px;
        line-height: 53px;
        text-align: center;
      }
      .primary {
        color: #fff;
        background-color: $theme;
      }
      .white {
        color: $theme;
        background-color: #fff;
        margin-left: 25px;
      }
    }
    .line {
      margin-top: 40px;
      background-color: $theme;
      width: 49px;
      height: 8px;
    }
  }
}

.navs {
  width: fit-content;
  height: 100px;
  margin: -50px auto 0;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 16px 0 16px rgba($color: #0454d8, $alpha: 0.11);
  position: relative;
  z-index: 2;

  a {
    color: #000;
  }
  .nav {
    padding: 5px 20px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      .name {
        color: $theme;
      }
    }
    &:not(:first-child) {
      border-left: 2px solid #e9ecf0;
    }
    .icon {
      width: auto;
      height: 50px;
    }
    .name {
      font-size: 18px;
      margin-left: 10px;
    }
  }
  .active {
    .name {
      color: $theme;
    }
  }
}

.contact {
  padding-bottom: 80px;

  .type-banner {
    width: 100%;
    height: 360px;
    object-fit: cover;
  }
  .bottom {
    width: 950px;
    margin: 0 auto;
    display: flex;

    .left {
      width: 340px;
      height: 530px;
      background-color: $theme;
      padding: 70px 40px 0;
      box-sizing: border-box;
      color: #fff;
      margin-top: -100px;

      .title {
        font-size: 30px;

        &::after {
          content: "";
          display: block;
          width: 44px;
          height: 4px;
          background-color: #f9e432;
          margin-top: 5px;
          margin-left: 2px;
        }
      }
      .sub {
        font-size: 20px;
        margin-top: 15px;
      }
      .steps {
        margin-top: 15px;

        .step {
          display: flex;
          align-items: center;
          margin-bottom: 20px;

          .order {
            width: 18px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            background-color: #fff;
            border-radius: 50%;
            color: $theme;
          }
          .txt {
            margin-left: 10px;
            letter-spacing: 3px;
          }
        }
      }
    }
    .right {
      flex-grow: 1;
      margin-left: 80px;
      margin-top: 50px;

      .item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        .label {
          width: 100px;
          font-size: 20px;
          letter-spacing: 3px;
        }
        .value {
          flex-grow: 1;
          margin-left: 15px;

          .ipt {
            width: 100%;
            height: 40px;
            border-radius: 12px;
            border: 1px solid #6e7685;
            text-indent: 15px;
          }
        }
      }
      .require {
        .label {
          position: relative;

          &::after {
            content: "*";
            color: red;
            position: absolute;
            left: -10px;
            top: 0;
          }
        }
      }
    }
  }
  .btn {
    margin-top: 100px;
    position: relative;
    text-align: center;
  }
  .submit {
    width: 250px;
    height: 50px;
    color: #fff;
    background-color: $theme;
    font-size: 25px;
    border-radius: 10px;
  }
  .phone {
    font-size: 25px;
    letter-spacing: 2px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(80%, -50%);
  }
}

@media (max-width: 1400px) {
  .banner .in {
    width: 1000px;
  }
  .navs {
    width: 1000px;

    .nav {
      flex: 1;
      flex-direction: column;
      padding: 5px 10px;

      &:not(:first-child) {
        border-width: 2px;
      }
      .icon {
        height: 40px;
      }
      .name {
        font-size: 16px;
        margin-top: 5px;
        margin-left: 0;
      }
    }
  }
}

.m-business {
  .banner {
    img {
      height: 165px;
      display: block;
    }
    .in {
      width: 90%;
      top: 20%;
      z-index: 2;
      padding: 0 20px;
      left: 0;
      transform: none;
      box-sizing: border-box;

      .btns {
        display: none;
      }
      .title {
        display: block;
        font-size: 22px;
      }
      .sub {
        margin-top: 10px;
        font-size: 12px;
        line-height: 1.5;
      }
    }
  }
  .navs {
    width: 100%;
    height: auto;
    flex-wrap: wrap;
    margin-top: 0;
    padding-top: 20px;
    border-radius: 0;

    .nav {
      width: 33%;
      flex: unset;
      border-left: none !important;
      box-sizing: border-box;
      margin-bottom: 20px;
    }
  }
  .contact {
    display: none;
  }
}
</style>
